<template>
	<div>
		<page-header :title="title"></page-header>
		<form @submit.prevent="gravar">
			<div class="modal-body">
				<div class="form-horizontal">
					<vue-element-loading :active="isActive" spinner="bar-fade-scale"
						color="#428BCA"></vue-element-loading>
					<div class="form-group">
						<select-form v-model="form.categoria_id" :value="form.categoria_id" name="Categoria"
							url="/categorias" id="id" titulo="title" layout="true" optionText="Selecione"
							required="true" :session="true"></select-form>
					</div>
					<input-form-text textInput="Título" :required="true" v-model="form.title"
						:value="form.title"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="data"> Data</label>
						<div class="col-sm-3">
							<flat-pickr class="col-xs-10 col-sm-3 form-control" v-model="form.datanot" :config="config"
								placeholder="Data" name="date"></flat-pickr>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="hora"> Hora</label>
						<div class="col-sm-9">
							<the-mask class="col-xs-10 col-sm-3 hora" type="text" v-model="form.timenot"
								placeholder="Hora" maxlength="5" :mask="['##:##']" required=""></the-mask>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Texto</label>
						<div class="col-sm-9">
							<editor v-model="form.content" style="height: 280px">
								<editor-tool :name="'formatting'"></editor-tool>
								<editor-tool :name="'bold'"></editor-tool>
								<editor-tool :name="'italic'"></editor-tool>
								<editor-tool :name="'underline'"></editor-tool>
								<editor-tool :name="'fontSize'"></editor-tool>
								<editor-tool :name="'foreColor'"></editor-tool>
								<editor-tool :name="'undo'"></editor-tool>
								<editor-tool :name="'redo'"></editor-tool>
								<editor-tool :name="'viewHtml'"></editor-tool>
								<editor-tool :name="'justifyLeft'"></editor-tool>
								<editor-tool :name="'justifyCenter'"></editor-tool>
								<editor-tool :name="'justifyRight'"></editor-tool>
								<editor-tool :name="'justifyFull'"></editor-tool>
								<editor-tool :name="'cleanFormatting'"></editor-tool>
								<editor-tool :name="'insertUnorderedList'"></editor-tool>
								<editor-tool :name="'insertOrderedList'"></editor-tool>
								<editor-tool :name="'indent'"></editor-tool>
								<editor-tool :name="'outdent'"></editor-tool>
								<editor-tool :name="'createLink'"></editor-tool>
								<editor-tool :name="'unlink'"></editor-tool>
								<editor-tool :name="'print'"></editor-tool>
							</editor>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right"></label>
						<div class="col-sm-5">
							<items-edit v-if="allImages.length" :files="allImages" url="/noticias/upload" :capa="true"></items-edit>
							<file-upload ref="fupload" :url="`/noticias/upload`" :id="null" :label="'PNG, JPG, GIF até 10 MB'"></file-upload>
							
						</div>
					</div>
					<input-form-text textInput="Fonte"  v-model="form.fonte"
						:value="form.fonte"></input-form-text>
					<div class="form-group">
						<select-form v-model="form.active" :value="form.active" name="Ativo" url="/arquivos" id="id"
							titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
					</div>
				</div>
			</div>
			<footer-button :disabled="isActiveBtn"></footer-button>
		</form>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.min.css'
import { Portuguese } from 'flatpickr/dist/l10n/pt.js'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import { TheMask } from 'vue-the-mask'
import 'clockpicker/dist/jquery-clockpicker.min'
import 'clockpicker/dist/bootstrap-clockpicker.min.css'
import '@progress/kendo-ui'
import '@progress/kendo-ui/css/web/kendo.default-v2.min.css'
import '@progress/kendo-ui/js/cultures/kendo.culture.pt-BR'
import '@progress/kendo-ui/js/messages/kendo.messages.pt-BR'
import { Editor, EditorTool, EditorInstaller } from '@progress/kendo-editor-vue-wrapper'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'

moment.locale('pt-BR')
// eslint-disable-next-line no-undef
kendo.culture('pt-BR')
Vue.use(EditorInstaller)

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		flatPickr,
		TheMask,
		Editor,
		EditorTool,
		fileUpload,
		ItemsEdit
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Notícias',
			form: {
				datanot: '',
				timenot: moment().format('LT'),
				categoria_id: '',
				title: '',
				content: '',
				fonte: '',
				active: '1'
			},
			isActive: false,
			isActiveBtn: false,
			config: {
				wrap: true, // set wrap to true only when using 'input-group'
				altInput: true,
				// eslint-disable-next-line no-useless-escape
				altFormat: 'd \\de F \\de Y',
				dateFormat: 'Y-m-d',
				locale: Portuguese
			},
			allImages: [],
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			this.isActiveBtn = true
			const body = this.form
			//this.setVersion()
			if (this.$route.params.id) {
				const resp = await req(`/noticias/${this.$route.params.id}`, 'put', body).catch(() => {
					erro()
				})
				this.isActive = false
				const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				await m.uploadAll(resp)
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/sistema/noticias')
			} else {
				const resp = await req('/noticias', 'post', body).catch(() => {
					erro()
				})
				this.isActive = false
				const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				await m.uploadAll(resp)
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/sistema/noticias')
			}
			this.isActiveBtn = false
		},
		async setVersion() {
			const dados = await req('/versao/1', 'put', {
				title: Date.now()
			})
			dados
		},
		async getDados() {
			const resp = await req(`/noticias/${this.$route.params.id}`).catch(() => {
				erro()
			})
			this.form.datanot = resp.datanot
			this.form.timenot = resp.timenot
			this.form.categoria_id = resp.categoria_id
			this.form.title = resp.title
			this.form.content = resp.content
			this.form.fonte = resp.fonte
			this.form.active = resp.active
			const images = await req(`/noticias/images/${this.$route.params.id}`).catch(() => {
				erro()
			})
			this.allImages = images
			this.isActive = false
			
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	created() {

	},
	mounted() {
		// eslint-disable-next-line no-undef
		$('.hora').clockpicker({
			placement: 'bottom',
			align: 'left',
			autoclose: true,
			'default': 'now'
		}).on('change', e => {
			this.form.timenot = e.target.value
		})

		this.form.datanot = moment(new Date()).format('YYYY-MM-DD')

		this.verifPermissao()

		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="scss">

</style>
